import * as Constants from '../constants/cms';

const initialState = {
  activeOnbeDowntimeWindow: null,
  apiDocumentationFile: null,
  apiDocumentationToken: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_ONBE_DOWNTIME_WINDOW_SUCCESS:
      return {
        ...state,
        activeOnbeDowntimeWindow: action.payload,
      };
    case Constants.SET_ONBE_DOWNTIME_WINDOW:
      return {
        ...state,
        activeOnbeDowntimeWindow: action.payload,
      };
    case Constants.GET_API_DOCUMENTATION_FILE_SUCCESS:
      return {
        ...state,
        apiDocumentationFile: action.payload,
      };
    case Constants.SET_API_DOCUMENTATION_FILE:
      return {
        ...state,
        apiDocumentationFile: action.payload,
      };
    case Constants.GET_API_DOCUMENTATION_TOKEN_SUCCESS:
      return {
        ...state,
        apiDocumentationToken: action.payload,
      };
    case Constants.SET_API_DOCUMENTATION_TOKEN:
      return {
        ...state,
        apiDocumentationToken: action.payload,
      };
    default:
      return state;
  }
};
